import React from 'react';
import { Box, Stack, Divider, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';


const techStatus = [
  { id: 1, value: '0', label: '제안영업', color: 'info' },
  { id: 2, value: '1', label: '착수보고', color: 'error' },
  { id: 3, value: '2', label: '분석설계', color: 'success' },
  { id: 4, value: '3', label: '구축(이행)', color: 'secondary' },
  { id: 5, value: '4', label: '완료(검수)', color: 'warning' },
]

const prjTyps = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
]


const TechStatusList = ({ searchGrade, onChangeGrade, searchPrjTyp, onChangePrjTyp }) => {

  return (
    <Box className="status-chip-list"
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box>
          {techStatus && techStatus.map((st, index) => (
            <Chip
              sx={{ mr: 2 }}
              key={index}
              icon={<CircleIcon />}
              label={st.label}
              variant={st.value === searchGrade ? 'contained' : 'outlined'}
              color={st.color}
              onClick={() => onChangeGrade(st.value)}
            />
          ))}
        </Box>
        <Box>
          {prjTyps && prjTyps.map((st, index) => (
            <Chip
              sx={{ mr: 2 }}
              key={index}
              icon={<CircleIcon />}
              label={st.label}
              variant={st.value === searchPrjTyp ? 'contained' : 'outlined'}
              color={st.color}
              onClick={() => onChangePrjTyp(st.value)}
            />
          ))}
        </Box>
      </Stack>

    </Box>
  )
};

export default TechStatusList;
